import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";
import { listAgenciesCompactAction, clearListCompactAction } from "../../../store/agency/agencyActions";
import { ManageInventory } from "../../shared/securityRoleTasks";
import SalesVolumeAndThresholdsForm from "./salesVolumeAndThresholds/form";
import PermissionWrapper from "../../navigation/PermissionWrapper";

const SalesVolumeAndThresholds = () => {
  const dispatch = useDispatch();
  const brokerId = useSelector((state) => state.actor.details.data.BrokerId);
  const homeAgency = useSelector((state) => state.actor.details.data.AgencyKey);
  const agencies = useSelector((state) => state.agency.listCompact);

  useEffect(() => {
    if (brokerId != null) {
      dispatch(listAgenciesCompactAction(brokerId, ManageInventory));
    }

    return () => {
      dispatch(clearListCompactAction());
    };
  }, [brokerId, dispatch]);

  const agenciesReady = !!(agencies?.length && homeAgency);

  return (
    <PermissionWrapper entityName="SalesVolumeAndThresholds">
      <Spin spinning={!agenciesReady} delay={300}>
        {agenciesReady && (
          <SalesVolumeAndThresholdsForm agencies={agencies} homeAgency={homeAgency} />
        )}
      </Spin>
    </PermissionWrapper>
  );
};

export default SalesVolumeAndThresholds;
